import React from 'react';
import GMDSSInspectorView from './gmdss/GMDSSInspectorView';
import CompassErrorInspectorView from './compassError/CompassErrorInspectorView';
import PortLogInspectorView from './port/PortLogInspectorView';
import EngineLogInspectorView from './engine/EngineLogInspectorView';
import DeckLogInspectorView from './deck/DeckLogInspectorView';
import { Dispatch } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import MedicalLogInspectorView from './medical/MedicalLogInspectorView';
import { IStore } from 'redux/store';
import { inspectorSelectors } from 'redux/app/vessel/inspector';
import { useParams } from 'react-router-dom';

const MarpolModule = (props: { bookId: string } & PropsFromRedux) => {
    const { bookId, selectedDate } = props;
	const params = useParams<{vesselId: string}>();
	const { vesselId } = params;

    switch (bookId) {
        case 'gmdssRadioConfig':
            return <GMDSSInspectorView vesselId={vesselId} selectedDate={selectedDate} />;
        case 'compassLogConfig':
            return <CompassErrorInspectorView vesselId={vesselId} selectedDate={selectedDate} />;
        case 'portLogConfig':
            return <PortLogInspectorView vesselId={vesselId} selectedDate={selectedDate} />;
        case 'engineLogConfig': // TODO: need to create cover-page content
            return <EngineLogInspectorView vesselId={vesselId} selectedDate={selectedDate} />;
        case 'deckLogConfig': // TODO: need to create cover-page content
            return <DeckLogInspectorView vesselId={vesselId} selectedDate={selectedDate} />;
        case 'medicalLogConfig': 
            return <MedicalLogInspectorView vesselId={vesselId} selectedDate={selectedDate} />;

        default:
            return (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    Requested marpol book is not available!
                </div>
            );
    }
};

function mapStateToProps(store: IStore) {
    const inspectorStore = inspectorSelectors._getStore(store);
    const selectedDate: string =
        inspectorSelectors.getSelectedLog(inspectorStore)?.log[0]
            ?.selectedDate ?? '';
    return {
        selectedDate,
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(MarpolModule);
